import { Box } from "@mui/material";
import React, { useState, useEffect, useCallback } from "react";
import styles from "./dealerDetails.module.scss";
import TextLabel from "../../../../components/textLabelComponent/TextLabelComponent";
import SubTitleHeader from "../../../../components/subTitleHeader/SubTitleHeader";
import i18next from "i18next";
import FooterButtonSection from "../../../../components/footerSection/FooterButtonSection";
import StatusText from "../../../../components/statusText/StatusText";
import { getLogoIcon } from "./logoComponent/LogoComponent";
import { getStatusClassName } from "../../../../utils/commonFuntion";
import _ from "lodash";
import {
  exportVehicleFromDealerDetails,
  getDealerDetails,
  getExactDetails,
} from "../../../../services/APIService";
import { useApiErrorModalContext } from "../../../../errorHandling/ApiErrorModalContext";
import { useLocation, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { downloadCsv } from "../../../../config/appConfig";

const DealerDetails = (props) => {
  // eslint-disable-next-line no-unused-vars
  const {
    dealerNo = 0,
    setDetailsDrawerState,
    setEditDrawerState,
    setLogDrawerState,
    setSnackAssignGroupMessage,
    setExactSubcriptionList,
  } = props;
  const { setApiErrorModalState } = useApiErrorModalContext();
  const history = useNavigate();
  const location = useLocation();

  const [certificateWarning, setCertificateWarning] = useState(false);

  const handleCertificateMatch = (value = [], CertificateList = []) => {
    setExactSubcriptionList({ value: value, certificate: CertificateList });
    if (_.isUndefined(CertificateList) || _.isEmpty(CertificateList)) {
      setCertificateWarning(false);
    } else if (value.length !== CertificateList.length) {
      setCertificateWarning(true);
    } else {
      setCertificateWarning(false);
    }
  };
  const onVehicleClick = useCallback(
    (vehicleDealerNumber) => {

      const stateValues = {
        vehicleDealerNumber: vehicleDealerNumber,
        ...location.state,
      };
      history(`/vehicles`, { state: stateValues });
      history(0);

    },
    [history, location.state]
  );

  const handleEditClick = () => {
    document.getElementById("contentWrapper")?.scrollIntoView();
    setDetailsDrawerState(false);
    setSnackAssignGroupMessage(false);
    setEditDrawerState(true);
  };

  const handleLogsClick = () => {
    document.getElementById("contentWrapper")?.scrollIntoView();

    setDetailsDrawerState(false);
    setLogDrawerState(true);
  };

  const handleDownLoadClick = (vehicleDealerNumber) => {
    exportVehicleFromDealerDetails(vehicleDealerNumber)
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          downloadCsv(response.fileData, response.fileName);
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });
  };
  
  const [dealerDetails, setDealerDetails] = useState({});

  useEffect(() => {
    getDealerDetails({ dealerId: dealerNo })
      .then((response) => {
        if (
          !_.isEmpty(_.get(response, "errorMessage", "")) ||
          _.get(response, "success", true) === false
        ) {
          _.set(response, "status", 200);

          setApiErrorModalState({ error: response });
        } else {
          setDealerDetails(response);
          const dealerCertificateList = _.get(response, "certificates", []);
          if (!_.isNull(_.get(response, "exact_Number", null))) {
            getExactDetails({
              exactNumber: _.get(response, "exact_Number", null),
            })
              .then((response) => {
                if (
                  !_.isEmpty(_.get(response, "errorMessage", "")) ||
                  _.get(response, "success", true) === false
                ) {
                  _.set(response, "status", 200);
                } else {
                  handleCertificateMatch(
                    dealerCertificateList,
                    _.get(response, "subscription_Type", [])
                  );
                }
              })
              .catch((err) => {
                setApiErrorModalState({ error: err });
              });
          } else {
            setExactSubcriptionList([]);
          }
        }
      })
      .catch((err) => {
        setApiErrorModalState({ error: err });
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      className={styles.dealerDetailsWrapper}
      id="dealerDetailsWrapper"
      data-testid="DealerDetails"
    >
      <Box className={styles.detailWrapper1}>
        <Box className={styles.detailWrapper2}>
          <Box className="textboxDoubleWraper">
            <Box class={styles.textWrapper}>
              <Box class={styles.label}>{i18next.t("Dealer name")}</Box>
              <Box class={styles.labelValues}>
                {_.get(dealerDetails, "dealer_Name", "-")}
              </Box>
            </Box>
          </Box>
          <Box className="textboxDoubleWraper">
            <TextLabel
              label={i18next.t("Exact nummer")}
              value={_.get(dealerDetails, "exact_Number", "-")}
            />
            <TextLabel
              label={i18next.t("Province")}
              value={_.get(dealerDetails, "keyValuePairProvince.key", "-")}
            />
          </Box>

          <Box className="textboxThreeItemraper">
            <TextLabel
              label={i18next.t("Provider no.")}
              value={_.get(dealerDetails, "provider_Number", "-")}
            />
            <TextLabel
              label={i18next.t("Bovag no.")}
              value={_.get(dealerDetails, "bovag_Number", "-")}
            />
          </Box>

          <Box className="textboxDoubleWraper">
            <Box className={styles.statusBox}>
              <Box className={styles.label}>{i18next.t("Status")}</Box>

              <StatusText
                title={_.get(dealerDetails, "keyValuePairStatus.key", "-")}
                customClass={getStatusClassName(
                  _.get(dealerDetails, "keyValuePairStatus.key", "")
                )}
                hasIcon={false}
                showPopover={false}
              />
            </Box>
            <Box className={styles.statusBox}>
              <Box className={styles.label}>{i18next.t("Assigned label")}</Box>

              <Box className={styles.labelImgBox}>
                {!_.isEmpty(_.get(dealerDetails, "certificates", []))
                  ? _.get(dealerDetails, "certificates", []).map(
                    (certificate, index) => {
                      return getLogoIcon(
                        _.get(certificate, "value", ""),

                        index,
                        ""
                      );
                    }
                  )
                  : ""}
              </Box>

              <Box>
                {certificateWarning ? (
                  <Box className={styles.existingCertificate}>
                    {`${i18next.t("*Niet overeen met Exact")}`}
                  </Box>
                ) : (
                  ""
                )}
              </Box>
            </Box>
          </Box>
          <Box className="textboxDoubleWraper">
            <TextLabel
              label={i18next.t("Kvk Number")}
              value={_.get(dealerDetails, "kvK_Number", "-")}
            />
            <TextLabel
              label={i18next.t("KvK vestigingsnummer")}
              value={_.get(dealerDetails, "kvK_Vestigings_Number", "-")}
            />
          </Box>

          <Box className="textboxDoubleWraper">
            <TextLabel
              label={i18next.t("Software systeem")}
              value={_.get(
                dealerDetails,
                "keyValuePairSoftwareSystem.key",
                "-"
              )}
            />

            <TextLabel
              label={i18next.t("Bron")}
              value={_.get(dealerDetails, "keyValuePairSource.key", "-")}
            />
          </Box>
          <Box className="textboxDoubleWraper">
            <TextLabel
              label={i18next.t("Combine certificates")}
              value={
                _.get(dealerDetails, "combine_Certificate", false)
                  ? "Ja"
                  : "Nee"
              }
            />
            <Box className="largeTextboxWraper">
              <TextLabel
                label={i18next.t("Opmerkingen")}
                value={_.get(dealerDetails, "comments", "-")}
              />
            </Box>
          </Box>
        </Box>
        <Box className={styles.detailWrapper3}>
          <Box className={styles.communicationWrapper}>
            <SubTitleHeader title={i18next.t("Communication details")} />
            <Box className="textboxDoubleWraper">
              <TextLabel
                label={i18next.t("Email address")}
                value={_.get(dealerDetails, "email_Id", "-")}
              />
              <TextLabel
                label={i18next.t("certificate email")}
                value={_.get(dealerDetails, "certificate_Email_Id", "-")}
              />
            </Box>
            <Box className="textboxDoubleWraper">
              <TextLabel
                label={i18next.t("Phone_Number")}
                value={_.get(dealerDetails, "contact_Number", "-")}
              />
            </Box>
            <Box className="largeTextboxWraper">
              <TextLabel
                label={i18next.t("Address")}
                value={`${_.get(dealerDetails, "street", "-")}
                ${_.get(dealerDetails, "house_Number", "-")}
                ${_.get(dealerDetails, "additional_House_Number", "-") !== null
                    ? _.get(dealerDetails, "additional_House_Number", "-")
                    : ""
                  }
                `}
                hasSubValue={true}
                subValue={`${_.get(dealerDetails, "postcode", "-")
                  .toUpperCase()
                  .replace(/\s/g, "")}
                ${_.get(dealerDetails, "city", "-")}
                `}
              />
            </Box>
          </Box>
        </Box>
      </Box>
      <FooterButtonSection
        btnlist={[
          {
            title: "Download vehicle list",
            iconStyle: "",
            buttonType: "muibtn-secondary-with-border-without-icon",
            attriType: "button",
            withIcon: false,
            showCountSection: false,
            count: "",
            handleClick: () => handleDownLoadClick(_.get(dealerDetails, "dealer_Id", 0)),
          },
          {
            title: "View dealer-log",
            iconStyle: "",
            buttonType: "muibtn-secondary-with-border-without-icon",
            attriType: "button",
            withIcon: false,
            showCountSection: false,
            count: "",
            handleClick: () => handleLogsClick(),
          },
          {
            title: "Vehicles List",
            iconStyle: "",
            buttonType: "muibtn-secondary-with-border-with-count",
            attriType: "button",
            withIcon: false,
            showCountSection: true,
            count: _.get(dealerDetails, "totalVehicles", "-"),
            handleClick: () =>
              onVehicleClick(_.get(dealerDetails, "dealer_Id", 0)),
          },
          {
            title: "Edit details",
            iconStyle: "",
            buttonType: "muibtn-primary",
            attriType: "button",
            withIcon: false,
            showCountSection: false,
            count: "",
            handleClick: () => handleEditClick(),
          },
        ]}
      />
    </Box>
  );
};
export default DealerDetails;
DealerDetails.propTypes = {
  dealerNo: PropTypes.any,
  setDetailsDrawerState: PropTypes.any,
  setEditDrawerState: PropTypes.any,
  setLogDrawerState: PropTypes.any,
  setSnackAssignGroupMessage: PropTypes.any,
  setExactSubcriptionList: PropTypes.any,
};
